const patientSafetyData = {
  title: "Patient Safety",
  subtitle: "20+ Safety Measures at Dhotrad’s Sunny Dental Clinics",
  intro:
    "With concern towards the safety of our patients, the following safety measures have been incorporated at our clinics:",

  safetyMeasures: [
    "Priority to emergency and urgent treatment",
    "Treatment on prior appointment basis",
    "Online consultation, appointment and patient screening",
    "Pre-treatment patient screening",
    "Digitalized medical and travel history recording",
    "Pre-treatment COVID-19 questionnaire",
    "Telephonic discussion of treatment protocol",
    "Infra-red non-contact temperature screening",
    "Pulse oximeter oxygen saturation check",
    "Sanitization at clinic entry",
    "Disposable gloves, masks and shoe covers",
    "Doctors and staff in complete PPE",
    "One-time use PPE kits",
    "Multi-stage instrument sterilization",
    "Cubicle sanitization after every patient",
    "Separate cubicles for each dental chair",
    "UV-C and chemical sterilization protocols",
    "Aerosol removal and air purifying devices",
    "Contactless digital payments",
    "Responsible biomedical waste disposal",
    "Comprehensive patient care and support",
  ],

  convenienceTitle: "11 Points of Convenience",
  conveniencePoints: [
    "Digital appointment booking",
    "Digitalized patient history",
    "Contactless temperature checks",
    "Sanitization at entry",
    "Pulse oximeter screening",
    "Patient protective gear",
    "Regular clinic sanitization",
    "Advanced sterilization protocols",
    "Contactless payment",
    "Responsible waste disposal",
    "Understanding",
  ],
};

export default patientSafetyData;
